import axios from "axios";
import baseURL from "@/request/url.js"
import load from "@/utils/loading.js"
export function multiplication(a, b) {
    let n = (Number(a) || 0) * (Number(b) || 0);
    return n || 0;
}
export function multiplication2(a, b, c, d) {
    let n = (Number(a) || 0) * (Number(b) || 0)
        + (Number(c) || 0) * (Number(d) || 0);
    return n || 0;
}

export function getExportExcel(u, p, n) {
    load.show();
    let params = Object.assign(p);
    axios
        .get(baseURL + u, {
            params,
            responseType: 'arraybuffer',
        })
        .then((response) => {
            let contentType = response.headers['content-type'] || response.headers['Content-Type'];

            if (contentType && contentType.includes('application/json')) {
                let jsonString = new TextDecoder('utf-8').decode(response.data);
                try {
                    let res = JSON.parse(jsonString);
                    if (res.code == 2000) {
                        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = n + '.xlsx';
                        link.click();
                    } else {
                        messageShow(res, window.vm);
                    }
                } catch (e) {
                    let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = n + '.xlsx';
                    link.click();
                }
            } else {
                let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = n + '.xlsx';
                link.click();
            }
            load.close();
        }).catch((error) => {
            console.error('API Request Failed:', error);
            load.close();
        });
}


export function postExportExcel(u, p, n) {
    load.show();
    let params = Object.assign(p);
    axios
        ({
            url: baseURL + u,
            method: 'post',
            data: params,
            responseType: 'arraybuffer',
        })
        .then((response) => {
            console.log(response, u, p, n, 'ff');

            let contentType = response.headers['content-type'] || response.headers['Content-Type'];

            if (contentType && contentType.includes('application/json')) {
                let jsonString = new TextDecoder('utf-8').decode(response.data);
                try {
                    let res = JSON.parse(jsonString);
                    console.log(res, 'kkk');

                    if (res.code == 2000) {
                        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = n + '.xlsx';
                        link.click();
                    } else {
                        messageShow(res, window.vm);
                    }
                } catch (e) {
                    let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = n + '.xlsx';
                    link.click();
                }
            } else {
                let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = n + '.xlsx';
                link.click();
            }
            load.close();
        }).catch((error) => {
            console.error('API Request Failed:', error);
            load.close();
        });
}
// 2000 一般是成功
// 4000  错误消息 info不是数组
// 4002  导入的警告报错，info里面是导入错误的数组
export function messageShow(res, vm) {
    // 当作为 Vue 原型方法 `this.$messageShow(res)` 调用时，
    // `vm` 可能未传入；此处回退到函数的 this（组件实例）或全局 window.vm
    vm = vm || (typeof this !== 'undefined' && this) || (typeof window !== 'undefined' && window.vm);
    if (!vm) {
        // 如果仍然未找到 vm，降级到控制台输出并返回
        console.warn('messageShow: vm not found, logging message to console', res);
        return;
    }

    if (res.code == 2000) {
        console.log(res, 'res.data');
        if (Array.isArray(res.data)) {
            let str = [];
            var s = '';
            str = res.data;
            for (let i = 0; i < str.length; i++) {
                s += str[i] + '<br/>';
            }
            vm.$message({
                type: 'success',
                showClose: true,
                duration: 0,
                dangerouslyUseHTMLString: true,
                message: s
            });
        } else {
            vm.$message.success(res.msg);
        }
    } else if (res.code == 2001) {
        vm.$message.success(res.msg);
    } else if (res.code == 4000) {
        if (Array.isArray(res.data.info)) {
            let str = [];
            var s = '';
            str = res.data.info;
            for (let i = 0; i < str.length; i++) {
                s += str[i] + '<br/>';
            }
            vm.$message({
                type: 'error',
                showClose: true,
                duration: 0,
                dangerouslyUseHTMLString: true,
                message: s
            });
        } else {
            vm.$message.error(res.data.info);
        }
    } else if (res.code == 4002) {
        let str = [];
        var s = '';
        str = res.data.info;
        for (let i = 0; i < str.length; i++) {
            s += str[i] + '<br/>';
        }
        vm.$message({
            type: 'error',
            showClose: true,
            duration: 0,
            dangerouslyUseHTMLString: true,
            message: s
        });
    }


}
// export function postExportExcel(u, d, n) {
//     let data = Object.assign(d);
//     axios({
//         url: baseURL + u,
//         method: 'post',
//         data,
//         responseType: 'arraybuffer'
//     }).then((res) => {
//         //创建一个blob对象,file的一种
//         let blob = new Blob([res.data], { type: 'application/x-xls' });
//         let link = document.createElement('a');
//         link.href = window.URL.createObjectURL(blob);
//         link.download = n + '.xlsx';
//         link.click();
//     });
// }
